/**
 * Unit conversion utilities for consistent calculations across the system
 */

// Convert any unit to kg (base unit for weight)
export const toKg = (quantity, unit) => {
  const qty = parseFloat(quantity || 0);
  const unitLower = (unit || '').toLowerCase().trim();
  
  switch (unitLower) {
    case 'gr':
    case 'g':
    case 'gramo':
    case 'gramos':
      return qty / 1000;
    case 'mg':
    case 'miligramo':
    case 'miligramos':
      return qty / 1000000;
    case 'lb':
    case 'libra':
    case 'libras':
      return qty * 0.453592;
    case 'oz':
    case 'onza':
    case 'onzas':
      return qty * 0.0283495;
    case 'kg':
    case 'kilo':
    case 'kilos':
    case 'kilogramo':
    case 'kilogramos':
    default:
      return qty;
  }
};

// Convert any unit to liters (base unit for volume)
export const toLiters = (quantity, unit) => {
  const qty = parseFloat(quantity || 0);
  const unitLower = (unit || '').toLowerCase().trim();
  
  switch (unitLower) {
    case 'ml':
    case 'mililitro':
    case 'mililitros':
      return qty / 1000;
    case 'gal':
    case 'galon':
    case 'galones':
      return qty * 3.78541;
    case 'lt':
    case 'l':
    case 'litro':
    case 'litros':
    default:
      return qty;
  }
};

// Format number without excessive decimals
export const formatQuantity = (num, decimals = 2) => {
  const rounded = Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
  return rounded.toLocaleString('es-MX', { maximumFractionDigits: decimals });
};

// Format currency
export const formatMoney = (num) => {
  return Math.round(num || 0).toLocaleString('es-MX');
};
